import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useCookies } from 'react-cookie';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core';
import './locales';

import { SnackbarCloseButton } from './components/SnackBar';
import { SNACKBAR_TIME, SPLASH_TIME, basic, Values, oper as v_oper } from './request/values';
import ToastStr from './request/toastStr';
import HeaderEmptyLayout from './shared/commonStyles/headerEmpty/HeaderEmptyLayout';
import Layout from './shared/commonStyles/headerContain/Layout';
import useGlobalStyles from './shared/commonStyles/globalStyles';
import OperationLayout from './shared/commonStyles/headerContain/OperationLayout';

import useMember from './components/useMember';
import Splash from './components/Splash';
import Setting from './components/Setting';
import QnA from './components/QnA';
import PrivacyV1 from './components/privacy_v1';
import PrivacyV2 from './components/privacy_v2';
import PrivacyV3 from './components/privacy_v3';
import DeleteUserAccount from './student/common/DeleteUserAccount';

/* Sub Admin */
import AdminLogin from './admin/auth/adminLogin';
import AdminSignin from './admin/auth/adminSignin';
import SubAdminManageClass from './admin/sub_admin/subAdminManageClass';
import SubAdminClassList from './admin/sub_admin/subAdminClassList';
import SubAdminClassList2 from './admin/sub_admin/subAdminClassList2';
import SubAdminClassInfo from './admin/sub_admin/subAdminClassInfo';
import SubAdminCreateClass from './admin/sub_admin/subAdminCreateClass';
import SubAdminClassManageNav from './admin/sub_admin/subAdminClassManageNav';
import SubAdminClassRun from './admin/sub_admin/subAdminClassRun';
import SubAdminClassMember from './admin/sub_admin/subAdminClassMember';
import SubAdminModifyClass from './admin/sub_admin/subAdminModifyClass';
import SubAdminOpenRanking from './admin/sub_admin/subAdminOpenRanking';
import SubAdminOperList from './admin/sub_admin/subAdminOperList';
import SubAdminOperAffiliate from './admin/sub_admin/subAdminOperAffiliate';

/* Head Admin */
import HeadAdminLogin from './admin/auth/headAdminLogin';
import HeadAdminClassList from './admin/head_admin/headAdminClassList';
import HeadAdminClassManageNav from './admin/head_admin/headAdminClassManageNav';
import HeadAdminManageClass from './admin/head_admin/headAdminManageClass';
import HeadAdminClassMember from './admin/head_admin/headAdminClassMember';
import HeadAdminMemberList from './admin/head_admin/headAdminMemberList';
import HeadAdminAccountManage from './admin/head_admin/headAdminAccountManage';
import HeadAdminMaterialList from './admin/head_admin/headAdminMaterialList';
import HeadAdminLicenseList from './admin/head_admin/headAdminLicenseList';
import HeadAdminCreateClass from './admin/head_admin/headAdminCreateClass';
import HeadAdminAddMaterial from './admin/head_admin/headAdminAddMaterial';
import HeadAdminAddLicense from './admin/head_admin/headAdminAddLicense';
import HeadAdminClassRun from './admin/head_admin/headAdminClassRun';
import HeadAdminOpenRanking from './admin/head_admin/headAdminOpenRanking';
import HeadAdminModifyClass from './admin/head_admin/headAdminModifyClass';

/* Oper */
import OperLogin from './oper/OperLogin';
import OperJoin from './oper/OperJoin';
import OperCompanyList from './oper/OperCompanyList';
import OperDecompositionAppList from './oper/OperDecompositionAppList';
import OperClassRun from './oper/OperClassRun';
import OperOpenRanking from './oper/OperOpenRanking';
import OperPassword from './oper/OperPassword';
import OperCreateClass from './oper/OperCreateClass';
import OperClassCode from './oper/OperClassCode';
import OperOpenClass from './oper/OperOpenClass';

/* Student */
import LoanList from './student/common/company/LoanList';
import CompanyInfo from './student/common/company/CompanyInfo';
import ClassEnter from './student/common/createProcess/ClassEnter';
import NameInput from './student/common/createProcess/NameInput';
import CompanyAppStandBy from './student/common/createProcess/CompanyAppStandBy';
import CompanyAppList from './student/common/company/CompanyAppList';
import CompanyEditMember from './student/common/company/CompanyEditMember';
import CompanyAsset from './student/common/company/CompanyAsset';
import CompanyProcess from './student/common/createProcess/CompanyProcess';

/* Manufacture */
import LicenseList from './student/manufacture/license/LicenseList';
import LicenseManual from './student/manufacture/license/LicenseManual';
import LicenseMaterial from './student/manufacture/license/LicenseMaterial';
import ProducitonList from './student/manufacture/product/ProductionList';
import MaterialPurchase from './student/manufacture/material/MaterialPurchase';
import MaterialPurchaseList from './student/manufacture/material/MaterialPurchaseList';
import MaterialPurchaseSheet from './student/manufacture/material/MaterialPurchaseSheet';
import ProductList from './student/manufacture/product/ProductList';
import ProductSaleList from './student/manufacture/product/ProductSaleList';

/* Distribution */
import MaterialSale from './student/distribution/material/MaterialSale';
import MaterialSaleSheet from './student/distribution/material/MaterialSaleSheet';
import MaterialOrderList from './student/distribution/material/MaterialOrderList';
import MaterialOrderSheet from './student/distribution/material/MaterialOrderSheet';
import ProductPurchase from './student/distribution/product/ProductPurchase';
import ProductOrderList from './student/distribution/product/productOrderList';
import ProductPurchaseList from './student/distribution/product/ProductPurchaseList';
import axios from 'axios';

const useStyles = makeStyles({
	snackBar: {
		'& .SnackbarItem-action-*': {
			paddingLeft: 0,
		},
		'& > #notistack-snackbar': {
			'&:hover ~ $b': {
				backgroundColor: '#ccc',
			},
		},
	},
});

axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response && error.response.status === 401) {
			console.log('401 인증 에러 감지!');

			//1. 강제 새로고침이 필요하다면:
			window.location.reload();
		}
		return Promise.reject(error);
	}
);

export interface iMember {
	email: string | null;
	classCode: string | null;
	companyNum: number | null;
	name: string | null;
	companyType: string | null;
}

// 종료+1시간이면 createClass로. OpenRanking만 예외.
function OperClassGuard({ member, children }: { member: any; children: React.ReactElement }) {
	const memberCode = String(member?.classCode ?? '').trim();
	const location = useLocation();
	const { enqueueSnackbar } = useSnackbar();
	const [allow, setAllow] = useState<boolean | null>(null);

	useEffect(() => {
		setAllow(null);

		if (!memberCode) {
			setAllow(false);
			return;
		}
		if (location.pathname.indexOf('/operation/OpenRanking') === 0) {
			setAllow(true);
			return;
		}

		axios({
			method: 'GET',
			withCredentials: true,
			url: basic.server + v_oper.oper + v_oper.class_info,
			params: { classCode: memberCode },
		})
			.then((res) => res.data)
			.then((data: any) => {
				let expired = false;
				if (data.code == Values.SUCCESS_CODE) {
					const endDate = data.classInfo[0].end_date;
					if (endDate) {
						const end = new Date(typeof endDate === 'string' ? endDate.replace(' ', 'T') + 'Z' : endDate);
						expired = Date.now() >= end.getTime() + 60 * 60 * 1000;
					}
				}
				if (expired) {
					enqueueSnackbar(ToastStr.CLASS_ENDED_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
						preventDuplicate: true,
					});
				}
				setAllow(!expired);
			})
			.catch(() => {
				setAllow(true);
			});
	}, [memberCode, location.pathname]);

	if (allow === null) return null;
	if (!allow) return <Redirect to="/operation/createClass" />;
	return children;
}

function App(props: any) {
	const classes = useStyles();
	const [cookies, setCookie, removeCookie] = useCookies();
	const { member, setMember, deleteMember, refreshCookie, fetchOperInfo } = useMember();
	const [loading, setLoading] = useState(false);
	const { token } = props;
	useGlobalStyles();

	useEffect(() => {
		const initializeAuth = async () => {
			const loginData = new URLSearchParams(window.location.search).get('login');
			if (loginData) {
				deleteMember();
				setLoading(true);
				return;
			}

			if (cookies['access'] === undefined) {
				const refreshResult = await refreshCookie();
				if (refreshResult === false) {
					setLoading(true);
					return;
				}
			}
			if (member == null) {
				setTimeout(() => {
					setLoading(true);
				}, SPLASH_TIME);
			} else {
				if (member.type === 'oper') {
					fetchOperInfo();
				}
				setLoading(true);
			}
		};
		initializeAuth();
	}, []);

	if (!loading) {
		return <Splash />;
	}

	//회원가입 전 페이지
	if (!member || member.type === undefined) {
		console.log('before login');
		return (
			<SnackbarProvider
				maxSnack={3}
				autoHideDuration={SNACKBAR_TIME}
				style={{
					fontSize: '3vw',
				}}
				className={classes.snackBar}
				// action={key => <SnackbarCloseButton key={key} />}
				action={(key) => SnackbarCloseButton(key)}
			>
				<div style={{ backgroundColor: '#ffffff' }}>
					<BrowserRouter>
						<Switch>
							<Redirect exact from="/" to="/ClassEnter" />
							<Route
								path="/ClassEnter"
								render={() => (
									<HeaderEmptyLayout>
										<ClassEnter member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>

							<Route exact path="/operation" component={() => <OperLogin oper={member} setOper={setMember} />}></Route>
							<Route path="/operation/join" component={() => <OperJoin oper={member} setOper={setMember} />}></Route>
							<Route path="/operation/password" component={() => <OperPassword oper={member} setOper={setMember} />}></Route>
							<Route exact path="/admin" component={() => <AdminLogin member={member} setMember={setMember} token={token} />}></Route>
							<Route exact path="/signin" component={() => <AdminSignin member={member} setMember={setMember} />}></Route>

							<Route exact path="/headadmin" component={() => <HeadAdminLogin member={member} setMember={setMember} token={token} />}></Route>
							<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
							<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
							<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
							<Route
								exact
								path="/*"
								render={() => (
									<HeaderEmptyLayout>
										<ClassEnter member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							></Route>
						</Switch>
					</BrowserRouter>
				</div>
			</SnackbarProvider>
		);
		//앱 내 운영진 페이지
	} else if (member.type === 'oper') {
		return (
			<SnackbarProvider
				maxSnack={3}
				autoHideDuration={SNACKBAR_TIME}
				style={{
					fontSize: '3vw',
				}}
				className={classes.snackBar}
				// action={key => <SnackbarCloseButton key={key} />}
				action={(key) => SnackbarCloseButton(key)}
			>
				<div style={{ backgroundColor: '#ffffff' }}>
					<BrowserRouter>
						<Switch>
							<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
							<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
							<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
							<Route
								path="/operation/createClass"
								component={() => (
									<HeaderEmptyLayout>
										<OperCreateClass member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								path="/operation/openClass"
								component={() => (
									<HeaderEmptyLayout>
										<OperOpenClass member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/setting"
								component={() => (
									<HeaderEmptyLayout>
										<OperClassGuard member={member}>
											<Setting member={member} setMember={setMember} deleteMember={deleteMember} />
										</OperClassGuard>
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/qna"
								component={() => (
									<HeaderEmptyLayout>
										<QnA member={member} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/deleteUserAccount"
								component={() => (
									<HeaderEmptyLayout isBackground={true}>
										<DeleteUserAccount member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								path="/operation/ClassRun"
								component={() => (
									<OperClassGuard member={member}>
										<OperClassRun oper={member} />
									</OperClassGuard>
								)}
							/>
							<Route
								path="/operation/OpenRanking"
								component={() => (
									<OperClassGuard member={member}>
										<OperOpenRanking oper={member} />
									</OperClassGuard>
								)}
							/>
							<OperationLayout oper={member}>
								<Switch>
									<Route exact path="/" render={() => <Redirect to="/operation/company/list" />} />
									<Route exact path="/operation/openClass" render={() => <Redirect to="/operation/openClass" />} />
									<Route
										path="/operation/company/list"
										render={() => (
											<OperClassGuard member={member}>
												<OperCompanyList oper={member} setMember={setMember} />
											</OperClassGuard>
										)}
									/>
									<Route
										path="/operation/decomposition/appList"
										render={() => (
											<OperClassGuard member={member}>
												<OperDecompositionAppList oper={member} />
											</OperClassGuard>
										)}
									/>
									<Route
										path="/operation/classCode"
										render={() => (
											<OperClassGuard member={member}>
												<OperClassCode oper={member} />
											</OperClassGuard>
										)}
									/>

									<Redirect exact from="*" to="/operation/createClass" />
								</Switch>
							</OperationLayout>

							<Switch></Switch>
						</Switch>
					</BrowserRouter>
				</div>
			</SnackbarProvider>
		);
		//운영자 페이지
	} else if (member.type === 'subAdmin') {
		return (
			<SnackbarProvider
				maxSnack={3}
				autoHideDuration={SNACKBAR_TIME}
				style={{
					fontSize: '3vw',
				}}
				className={classes.snackBar}
				// action={key => <SnackbarCloseButton key={key} />}
				action={(key) => SnackbarCloseButton(key)}
			>
				<div style={{ backgroundColor: '#ffffff' }}>
					<BrowserRouter>
						<Switch>
							<Route exact path="/operation" component={() => <OperLogin oper={member} setOper={setMember} />} />
							<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
							<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
							<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
							{<Redirect exact from="/admin" to="/subAdminClassList" />}
							<Route exact path="/subAdminClassList" component={() => <SubAdminClassList member={member} deleteMember={deleteMember} />} />
							<Route exact path="/subAdminClassList2" component={() => <SubAdminClassList2 member={member} deleteMember={deleteMember} />} />
							<Route exact path="/subAdminClassManage" component={() => <SubAdminManageClass member={member} deleteMember={deleteMember} />} />

							<Route path="/subAdminClassManageNav" component={() => <SubAdminClassManageNav member={member} deleteMember={deleteMember} />} />
							<Route path="/subAdminClassInfo" component={() => <SubAdminClassInfo member={member} />} />
							<Route path="/subAdminClassRun" component={() => <SubAdminClassRun member={member} />} />
							<Route path="/subAdminClassMember" component={() => <SubAdminClassMember member={member} />} />
							<Route path="/subAdminOpenRanking" component={() => <SubAdminOpenRanking member={member} />} />
							<Route exact path="/subAdminOperList" component={() => <SubAdminOperList member={member} />} />
							<Route exact path="/subAdminOperAffiliate" component={() => <SubAdminOperAffiliate member={member} />} />
							<Route
								path="/subAdminModifyClass"
								component={() => (
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<SubAdminModifyClass member={member} />
									</LocalizationProvider>
								)}
							/>
							<Route
								exact
								path="/subAdminCreateClass"
								component={() => (
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<SubAdminCreateClass member={member} />
									</LocalizationProvider>
								)}
							/>
							<Redirect exact from="*" to="/subAdminClassList" />
						</Switch>
					</BrowserRouter>
				</div>
			</SnackbarProvider>
		);
		//관리자 페이지
	} else if (member.type === 'headadmin') {
		return (
			<SnackbarProvider
				maxSnack={3}
				autoHideDuration={SNACKBAR_TIME}
				style={{
					fontSize: '3vw',
				}}
				className={classes.snackBar}
				// action={key => <SnackbarCloseButton key={key} />}
				action={(key) => SnackbarCloseButton(key)}
			>
				<div style={{ backgroundColor: '#ffffff' }}>
					<BrowserRouter>
						<Switch>
							<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
							<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
							<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
							{<Redirect exact from="/headadmin" to="/headAdminClassList" />}
							<Route path="/headAdminMemberList" component={() => <HeadAdminMemberList member={member} deleteMember={deleteMember} />} />

							<Route exact path="/headAdminClassList" component={() => <HeadAdminClassList member={member} deleteMember={deleteMember} />} />
							<Route path="/headAdminCreateClass" component={() => <HeadAdminCreateClass member={member} />} />

							<Route exact path="/headAdminClassManage" component={() => <HeadAdminManageClass member={member} deleteMember={deleteMember} />} />
							<Route path="/headAdminClassManageNav" component={() => <HeadAdminClassManageNav member={member} deleteMember={deleteMember} />} />
							<Route path="/headAdminClassMember" component={() => <HeadAdminClassMember member={member} />} />

							<Route exact path="/headAdminMaterialList" component={() => <HeadAdminMaterialList member={member} deleteMember={deleteMember} />} />
							<Route path="/headAdminAddMaterial" component={() => <HeadAdminAddMaterial member={member} />} />

							<Route exact path="/headAdminLicenseList" component={() => <HeadAdminLicenseList member={member} deleteMember={deleteMember} />} />
							<Route path="/headAdminAddLicense" component={() => <HeadAdminAddLicense member={member} />} />

							<Route path="/headAdminClassRun" component={() => <HeadAdminClassRun member={member} />} />
							<Route path="/headAdminModifyClass" component={() => <HeadAdminModifyClass member={member} />} />
							<Route path="/headAdminOpenRanking" component={() => <HeadAdminOpenRanking member={member} />} />

							<Route exact path="/headAdminAccountManage" component={() => <HeadAdminAccountManage member={member} deleteMember={deleteMember} />} />
						</Switch>
					</BrowserRouter>
				</div>
			</SnackbarProvider>
		);
		//회원가입 후 클래스 입장
	} else if (!member.companyNum || member.companyNum <= 0 || member.companyNum === null) {
		const LayoutRoutes = ({ member, setMember }: { member: iMember; setMember: (member: iMember) => void }) => (
			<HeaderEmptyLayout>
				<Switch>
					{(member.companyNum === 0 || member.companyNum === null) && (
						<>
							<Route path="/ClassEnter" component={() => <ClassEnter member={member} setMember={setMember} deleteMember={deleteMember} />} />
							<Redirect exact from="*" to="/ClassEnter" />
						</>
					)}
					{member.companyNum === -1 && (
						<>
							<Redirect exact from="/" to="/CompanyAppStandBy" />
							<Route path="/CompanyAppStandBy" component={() => <CompanyAppStandBy member={member} setMember={setMember} />} />
						</>
					)}
				</Switch>
			</HeaderEmptyLayout>
		);

		return (
			<SnackbarProvider
				maxSnack={3}
				autoHideDuration={SNACKBAR_TIME}
				style={{
					fontSize: '3vw',
				}}
				className={classes.snackBar}
				action={(key) => SnackbarCloseButton(key)}
			>
				<div style={{ backgroundColor: '#ffffff' }}>
					<BrowserRouter>
						<Switch>
							<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
							<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
							<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
							{!member.classCode && <Redirect exact from="/" to="/ClassEnter" />}
							{!member.name && <Redirect exact from="/" to="/NameInput" />}
							<Route exact path="/operation" component={() => <OperLogin oper={member} setOper={setMember} />} />
							<Route exact path="/admin" component={() => <AdminLogin member={member} setMember={setMember} token={token} />} />
							<Route
								exact
								path="/ClassEnter"
								render={() => (
									<HeaderEmptyLayout>
										<ClassEnter member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route path="/NameInput" component={() => <NameInput member={member} setMember={setMember} />} />
							<Route path="/CompanyProcess" component={() => <CompanyProcess member={member} setMember={setMember} />} />
							<Route path="*" component={() => <LayoutRoutes member={member} setMember={setMember} />} />
						</Switch>
					</BrowserRouter>
				</div>
			</SnackbarProvider>
		);
		//제조기업 화면
	} else if (member.companyType === 'M') {
		return (
			<SnackbarProvider
				maxSnack={3}
				autoHideDuration={SNACKBAR_TIME}
				style={{
					fontSize: '3vw',
				}}
				className={classes.snackBar}
				action={(key) => SnackbarCloseButton(key)}
			>
				<div style={{ backgroundColor: '#ffffff' }}>
					<BrowserRouter>
						<Switch>
							<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
							<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
							<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
							<Route
								path="/ClassEnter"
								render={() => (
									<HeaderEmptyLayout>
										<ClassEnter member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/setting"
								component={() => (
									<HeaderEmptyLayout>
										<Setting member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/qna"
								component={() => (
									<HeaderEmptyLayout>
										<QnA member={member} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/deleteUserAccount"
								component={() => (
									<HeaderEmptyLayout isBackground={true}>
										<DeleteUserAccount member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route exact path="/operation" component={() => <OperLogin oper={member} setOper={setMember} />} />
							<Route exact path="/admin" component={() => <AdminLogin member={member} setMember={setMember} token={token} />} />
							<Layout>
								<Route path="/">
									<Switch>
										<Redirect exact from="/" to="/CompanyInfo"></Redirect>
										<Route path="/CompanyInfo" component={() => <CompanyInfo member={member} />}></Route>
										<Route path="/CompanyAsset" component={() => <CompanyAsset member={member} />}></Route>
										<Route path="/LoanList" component={() => <LoanList member={member} />}></Route>
										<Route path="/CompanyAppList" component={() => <CompanyAppList member={member} />}></Route>
										<Route path="/CompanyEditMember" component={() => <CompanyEditMember member={member} />}></Route>
										{/* Manufacture */}
										<Route path="/LicenseList" component={() => <LicenseList member={member} />}></Route>
										<Route path="/LicenseManual" component={() => <LicenseManual />} />
										<Route path="/license/material/:licenseNum" render={(props) => <LicenseMaterial {...props} member={member} />}></Route>
										<Route path="/ProductionList" component={() => <ProducitonList member={member} />}></Route>
										<Route path="/MaterialPurchase" component={() => <MaterialPurchase member={member} />}></Route>
										<Route path="/MaterialPurchaseList" component={() => <MaterialPurchaseList member={member} />}></Route>
										<Route path="/MaterialPurchaseSheet/:orderNum" component={() => <MaterialPurchaseSheet member={member} />}></Route>
										<Route path="/ProductList" component={() => <ProductList member={member} />}></Route>
										<Route path="/ProductSaleList" component={() => <ProductSaleList member={member} />}></Route>
										<Route exact path="/*" render={() => <CompanyInfo member={member} />}></Route>
									</Switch>
								</Route>
							</Layout>
						</Switch>
					</BrowserRouter>
				</div>
			</SnackbarProvider>
		);
		//유통기업 화면
	} else if (member.companyType === 'D') {
		return (
			<SnackbarProvider
				maxSnack={3}
				autoHideDuration={SNACKBAR_TIME}
				style={{
					fontSize: '3vw',
				}}
				className={classes.snackBar}
				action={(key) => SnackbarCloseButton(key)}
			>
				<div style={{ backgroundColor: '#ffffff' }}>
					<BrowserRouter>
						<Switch>
							<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
							<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
							<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
							<Route
								path="/ClassEnter"
								render={() => (
									<HeaderEmptyLayout>
										<ClassEnter member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/setting"
								component={() => (
									<HeaderEmptyLayout>
										<Setting member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/qna"
								component={() => (
									<HeaderEmptyLayout>
										<QnA member={member} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route
								exact
								path="/deleteUserAccount"
								component={() => (
									<HeaderEmptyLayout isBackground={true}>
										<DeleteUserAccount member={member} setMember={setMember} deleteMember={deleteMember} />
									</HeaderEmptyLayout>
								)}
							/>
							<Route exact path="/operation" component={() => <OperLogin oper={member} setOper={setMember} />} />
							<Route exact path="/admin" component={() => <AdminLogin member={member} setMember={setMember} token={token} />} />
							<Layout isDistribution={true}>
								<Route path="/">
									<Switch>
										<Redirect exact from="/" to="/CompanyInfo"></Redirect>
										<Route path="/CompanyInfo" component={() => <CompanyInfo member={member} />}></Route>
										<Route path="/CompanyAsset" component={() => <CompanyAsset member={member} />}></Route>
										<Route path="/LoanList" component={() => <LoanList member={member} />}></Route>
										<Route path="/CompanyAppList" component={() => <CompanyAppList member={member} />}></Route>
										<Route path="/CompanyEditMember" component={() => <CompanyEditMember member={member} />}></Route>
										{/* Distribution */}
										<Route path="/MaterialSale" component={() => <MaterialSale member={member} />}></Route>
										<Route path="/MaterialSaleSheet/:orderNum" component={() => <MaterialSaleSheet member={member} />}></Route>
										<Route path="/MaterialOrderList" component={() => <MaterialOrderList member={member} />}></Route>
										<Route path="/MaterialOrderSheet/:orderNum" component={() => <MaterialOrderSheet member={member} />}></Route>
										<Route path="/ProductPurchase" component={() => <ProductPurchase member={member} />} />
										<Route path="/ProductOrderList" component={() => <ProductOrderList member={member} />} />
										<Route path="/ProductPurchaseList" component={() => <ProductPurchaseList member={member} />} />
										<Route exact path="/*" render={() => <CompanyInfo member={member} />}></Route>
									</Switch>
								</Route>
							</Layout>
						</Switch>
					</BrowserRouter>
				</div>
			</SnackbarProvider>
		);
	}

	return (
		<SnackbarProvider
			maxSnack={3}
			autoHideDuration={SNACKBAR_TIME}
			style={{
				fontSize: '3vw',
			}}
			className={classes.snackBar}
			action={(key) => SnackbarCloseButton(key)}
		>
			<div style={{ backgroundColor: '#ffffff' }}>
				<BrowserRouter>
					<Switch>
						<Route exact path="/privacy" component={() => <PrivacyV3 />}></Route>
						<Route exact path="/privacy_v2" component={() => <PrivacyV2 />}></Route>
						<Route exact path="/privacy_v1" component={() => <PrivacyV1 />}></Route>
						<Route exact path="/setting" component={() => <Setting member={member} setMember={setMember} deleteMember={deleteMember} />} />
						<Route exact path="/qna" component={() => <QnA member={member} />} />
						<Route exact path="/deleteUserAccount" component={() => <DeleteUserAccount member={member} setMember={setMember} deleteMember={deleteMember} />} />
						<Route exact path="/operation" component={() => <OperLogin oper={member} setOper={setMember} />} />
						<Route exact path="/admin" component={() => <AdminLogin member={member} setMember={setMember} token={token} />} />
						<Layout>
							<Route path="/">
								<Switch>
									<Redirect exact from="/" to="/CompanyInfo"></Redirect>
									<Route path="/CompanyInfo" component={() => <CompanyInfo member={member} />}></Route>
									<Route path="/CompanyAsset" component={() => <CompanyAsset member={member} />}></Route>
									<Route path="/LoanList" component={() => <LoanList member={member} />}></Route>
									<Route path="/CompanyAppList" component={() => <CompanyAppList member={member} />}></Route>
									<Route path="/CompanyEditMember" component={() => <CompanyEditMember member={member} />}></Route>
									{/* Manufacture */}
									<Route path="/LicenseList" component={() => <LicenseList member={member} />}></Route>
									<Route path="/LicenseManual" component={() => <LicenseManual />} />
									<Route path="/license/material/:licenseNum" render={(props) => <LicenseMaterial {...props} member={member} />}></Route>
									<Route path="/ProductionList" component={() => <ProducitonList member={member} />}></Route>
									<Route path="/MaterialPurchase" component={() => <MaterialPurchase member={member} />}></Route>
									<Route path="/MaterialPurchaseList" component={() => <MaterialPurchaseList member={member} />}></Route>
									<Route path="/MaterialPurchaseSheet/:orderNum" component={() => <MaterialPurchaseSheet member={member} />}></Route>
									<Route path="/ProductList" component={() => <ProductList member={member} />}></Route>
									<Route path="/ProductSaleList" component={() => <ProductSaleList member={member} />}></Route>
									<Route exact path="/*" render={() => <CompanyInfo member={member} />}></Route>
								</Switch>
							</Route>
						</Layout>
					</Switch>
				</BrowserRouter>
			</div>
		</SnackbarProvider>
	);
}

export default App;
